export default "__VITE_ASSET__DLofGMMN__"